import React, { useState } from "react";
import { Offcanvas, Form, Button, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const SaveFavReportsSidebar = ({ show, handleClose, onSave }) => {
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSaving(true);
        const formData = new FormData(event.target);

        // Simulating async save
        setTimeout(() => {
            if (onSave) {
                onSave({
                    name: formData.get("report_name"),
                    description: formData.get("report_description"),
                });
            }
            setSaving(false);
            handleClose();
        }, 1000);
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>Save Report</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex flex-column">
                <Form
                    className="mt-4 font-weight-normal d-flex flex-column flex-grow-1"
                    onSubmit={handleSubmit}
                >
                    <Form.Group className="mb-3" controlId="report_name">
                        <Form.Label>
                            Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter here"
                            name="report_name"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="report_description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder="Optional, up to 191 characters"
                    maxLength={191}
                            name="report_description"
                            maxLength={120}
                        />
                    </Form.Group>

                    <div className="d-flex align-items-center justify-content-end border-top pt-3 mt-auto">
                        <Button
                            variant="light"
                            className="bg-white border text-secondary me-2"
                            onClick={handleClose}
                        >
                            Discard
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={saving}
                        >
                            {saving && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                            )}
                            Save
                        </Button>
                    </div>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default SaveFavReportsSidebar;
